import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackViewDemo, trackViewFeatures, trackViewPricing } from './trackers';

const PUBLIC_PAGE_EVENTS = {
  '/': 'features',
  '/home': 'features',
  '/about': 'features',
  '/contact-sales': 'pricing',
  '/login': null,
  '/verify-email': null,
  '/privacy': 'features',
};

function firePublicPageEvent(pathname) {
  const kind = PUBLIC_PAGE_EVENTS[pathname];
  if (kind === 'features') trackViewFeatures({ page_path: pathname });
  if (kind === 'pricing') trackViewPricing({ page_path: pathname });
}

/**
 * Tracks SPA navigations as a single page_view per route change.
 * Sends SPA page_view via gtag — automatic page_view is disabled in gtag config (send_page_view: false).
 */
export default function AnalyticsRouteTracker() {
  const location = useLocation();
  const lastTrackedRef = useRef('');

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    if (lastTrackedRef.current === path) return;
    lastTrackedRef.current = path;

    trackPageView(path);

    const normalized = location.pathname.toLowerCase();
    firePublicPageEvent(normalized);

    if (normalized === '/contact-sales') {
      trackViewDemo({ page_path: normalized, context: 'contact_sales' });
    }
  }, [location.pathname, location.search]);

  return null;
}
